export function buildReceiptPopupTemplate(receiptNo) {
  return {
    icon: '🧾',
    title: 'ยืนยันเลขใบเสร็จ',
    subtitle: `เลขใบเสร็จ ${receiptNo}`,
    message: 'ระบบจะประมวลผลดวงมูเตลู และแสดงผลวิเคราะห์ทันที',
    confirmLabel: 'ดูผลคำทำนาย',
    cancelLabel: ''
  }
}

export function buildReceiptNotFoundPopupTemplate(receiptNo) {
  return {
    icon: '⚠️',
    title: 'เลขใบเสร็จไม่ถูกต้อง',
    subtitle: `เลขใบเสร็จ ${receiptNo}`,
    message: 'กรุณาตรวจสอบแล้วลองกรอกใหม่อีกครั้ง',
    confirmLabel: 'กรอกเลขใหม่',
    cancelLabel: 'ปิด'
  }
}

export function buildMeritCompletePopupTemplate() {
  return {
    icon: '💧',
    title: 'สรงน้ำครบแล้ว',
    subtitle: 'พลังบุญเต็ม 4/4',
    message: 'ทีมของคุณได้รับพลังเสริมเรียบร้อยแล้ว ลุยขั้นต่อไปได้เลย',
    confirmLabel: 'รับทรัพย์',
    cancelLabel: 'ปิด'
  }
}

export function buildApiErrorPopupTemplate({
  title = 'เชื่อมต่อไม่สำเร็จ',
  subtitle = 'เกิดข้อผิดพลาด',
  message = 'กรุณาลองใหม่อีกครั้ง'
} = {}) {
  return {
    icon: '⚠️',
    title,
    subtitle,
    message,
    confirmLabel: 'ตกลง',
    cancelLabel: ''
  }
}

export function buildApiSuccessPopupTemplate({
  title = 'สำเร็จ',
  subtitle = 'ทำรายการเรียบร้อย',
  message = 'ระบบบันทึกข้อมูลแล้ว'
} = {}) {
  return {
    icon: '✅',
    title,
    subtitle,
    message,
    confirmLabel: 'ตกลง',
    cancelLabel: ''
  }
}
